<wbo-edit-grid [data]="model.data[fieldName]" [editable]="true" [entityPath]="fieldName" [removable]="true"
               [title]="'wbo.report.supplier-selection.title'">
    <wbo-text-column [title]="'wbo.report.supplier-selection.column.name'" field="name"></wbo-text-column>
    <wbo-edit-grid-add-row [customAdd]="true">
        <wbo-edit-grid-add-row-quick-add (onSelect)="addFromSupplier([$event])">
            <wbo-supplier-single-select-edit-control></wbo-supplier-single-select-edit-control>
        </wbo-edit-grid-add-row-quick-add>
        <wbo-edit-grid-add-row-actions>
            <wbo-edit-grid-add-row-search (onSelect)="addFromSupplier($event)"
                                          [searchComponent]="SupplierSearchPageComponent"></wbo-edit-grid-add-row-search>
        </wbo-edit-grid-add-row-actions>
    </wbo-edit-grid-add-row>
</wbo-edit-grid>
